<template>
  <div class="flex items-center">
    {{ params.value | toDistanceFormat }} nm
  </div>
</template>

<script>

  export default {
    name: "CellRendererTotalDistance",
  };
</script>
